import { WhiteBloodCells } from "@cur8/health-risks-calc";
import { PathLink } from "@pomle/react-router-paths";
import { paths } from "render/routes/paths";
import { getMetricHistory } from "render/views/Report/AppointmentDataView/components/MetricsSection/components/metrics/utils/getMetricHistory";
import { useWhiteBloodCellsCountMetric } from "render/views/Report/AppointmentDataView/components/MetricsSection/hooks/usePatientReportMetrics";
import { Metric, MetricLoading } from "../../layouts/Metric";
import { Trans } from "./trans";

export function MetricWhiteBLoodCells() {
  const { data, isLoading: isDataLoading } = useWhiteBloodCellsCountMetric();

  if (isDataLoading) {
    return <MetricLoading label={<Trans.MetricName />} />;
  }

  if (!data) {
    return null;
  }

  const { cur, prev } = getMetricHistory(data);
  const riskRanges = WhiteBloodCells.rangesFor();
  const metricRating = cur && riskRanges.findRisk(cur.unit);
  const value = cur?.unit["x10⁹/L"];
  const prevValue = prev?.unit["x10⁹/L"];

  return (
    <PathLink to={paths.whiteBloodCellMetric.url({})}>
      <Metric
        metricRating={metricRating}
        label={<Trans.MetricName />}
        value={value}
        subLabel="x10⁹/L"
        previousValue={prevValue}
        showPreviousInsteadOfChange={true}
      />
    </PathLink>
  );
}
